import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-template-configuration',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './template-configuration.component.html',
  styleUrl: './template-configuration.component.css'
})
export class TemplateConfigurationComponent {

}